import { isPreaffectationSaveError } from './updatePreaffectation';

// Échec de l'enregistrement d'une préaffectation (plan 070b, Q19).
//
// Un refus du contrôle de modification (demande modifiée ou supprimée depuis
// l'ouverture, écriture sans effet) garde le tiroir ouvert et la saisie :
// bandeau + notification, sans rechargement automatique, qui effacerait la
// saisie. L'utilisateur recharge lui-même depuis le bandeau.
//
// Toute autre erreur suit le comportement par défaut du contrôleur d'édition
// de react-admin 3.19 (useEditController) : notification puis rechargement.
const handleSaveFailure = (error, { notify, refresh, setSaveError }) => {
  if (isPreaffectationSaveError(error)) {
    setSaveError(error);
    notify(error.message, 'warning', { _: error.message });
    return;
  }
  const message =
    typeof error === 'string'
      ? error
      : (error && error.message) || 'ra.notification.http_error';
  notify(message, 'warning', { _: message });
  refresh();
};

export default handleSaveFailure;
